import { render } from "./DirectoryReport.vue?vue&type=template&id=422634ca&scoped=true"
import script from "./DirectoryReport.vue?vue&type=script&lang=js"
export * from "./DirectoryReport.vue?vue&type=script&lang=js"

import "./DirectoryReport.vue?vue&type=style&index=0&id=422634ca&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shuha\\Documents\\Wisdom guide front\\wg-frontend-v1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-422634ca"]])

export default __exports__